import React from 'react';
import { FieldPath, FieldValues } from 'react-hook-form';
import { TimeInput } from '../inputs/time-input';
import { CommonControlProps, IntegratedFormControl } from './integrated-form-control';

type TimeInputProps = React.ComponentProps<typeof TimeInput>;
type Props<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = CommonControlProps<TFieldValues, TName> & {
    timeInputProps?: TimeInputProps;
    cRef?: React.Ref<HTMLInputElement>; // 	https://fettblog.eu/typescript-react-generic-forward-refs/
};

export const FormTimeInput = function FormTimeInput<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(props: Props<TFieldValues, TName>): React.ReactElement {
    const { timeInputProps, ...integratedFormControlProps } = props;
    const timeInputPropsMemo = React.useMemo(() => timeInputProps ?? {}, [timeInputProps]);
    const renderViewMode = React.useCallback((value: string) => {
        return value;
    }, []);
    return (
        <IntegratedFormControl
            {...integratedFormControlProps}
            renderViewMode={renderViewMode}
            cRef={props.cRef}
        >
            {(inputProps) => <TimeInput {...inputProps} {...timeInputPropsMemo} />}
        </IntegratedFormControl>
    );
};
